import { createDynamicThunk } from ".";

/**
 * LIST Client
 */
export const fetchClientsThunk = createDynamicThunk({
  typePrefix: "clients/fetchClientsThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT Client
 */
export const submitClientThunk = createDynamicThunk({
  typePrefix: "clients/submitClientThunk",
  endpoint: "/clients",
  method: "POST",
});
